"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PurchaseButton = exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _ObjectDetailBar = require("components/ObjectDetailBar");

var _class, _descriptor, _descriptor2, _temp, _class3, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _temp2;

var SpecialOfferHeaderBlock = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Block) {
  babelHelpers.inherits(SpecialOfferHeaderBlock, _Block);

  function SpecialOfferHeaderBlock() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, SpecialOfferHeaderBlock);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(SpecialOfferHeaderBlock)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "headerBackground", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "image", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "title", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "purchaseButton", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "summary", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "itemTitle", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(SpecialOfferHeaderBlock, [{
    key: "getChildren",
    value: function getChildren() {
      return _react.default.createElement("div", {
        className: ClassList.join('spotlight-header', this.headerBackground ? 'variable-background' : null),
        style: this.headerBackground ? _base.default.styleForBackgroundObject(this.headerBackground) : {}
      }, _react.default.createElement("div", {
        className: "inner-content animate-fadeIn"
      }, this.image && _react.default.createElement("img", {
        src: this.image,
        alt: ""
      }), this.title && _react.default.createElement("h2", null, this.title), _react.default.createElement("h3", null, this.itemTitle), _react.default.createElement(PurchaseButton, this.purchaseButton), _react.default.createElement("hr", null), this.summary && _react.default.createElement("div", {
        style: {
          display: 'contents'
        },
        dangerouslySetInnerHTML: {
          __html: this.summary
        }
      })));
    }
  }]);
  return SpecialOfferHeaderBlock;
}(_base.default), _temp2), (_descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "headerBackground", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "image", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "title", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "purchaseButton", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "summary", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "itemTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.default = SpecialOfferHeaderBlock;
var PurchaseButton = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(PurchaseButton, _Component);

  function PurchaseButton() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, PurchaseButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(PurchaseButton)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "status", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "button", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(PurchaseButton, [{
    key: "render",
    value: function render() {
      switch (this.status) {
        case 'available':
          return _react.default.createElement("div", null, _react.default.createElement("div", {
            className: "purchase-wrap"
          }, _react.default.createElement(_ObjectDetailBar.ObjectDetailButton, this.button)));

        case 'expired':
          return _react.default.createElement("p", null, _react.default.createElement("i", null, "We're sorry, this special offer has expired."));

        case 'ineligible':
        default:
          return _react.default.createElement("p", null, _react.default.createElement("i", null, "You are not eligible for this special offer."));
      }
    }
  }]);
  return PurchaseButton;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "status", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "button", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.PurchaseButton = PurchaseButton;